import { useMegaBroker } from '@tencent/mega-ipc-renderer';
class MegaRuntime {
    static get available() {
        return !!useMegaBroker();
    }
}
export default MegaRuntime;
//# sourceMappingURL=mega-runtime.js.map